(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/compact-format.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/compact-format.js');

'use strict';

const {
  RichTextState
} = svs.components.marketplaceRetailAdmin.richText.helpers;
const STORAGE_PREFIX = 'v2md:';
const FEATURE_TOGGLE_COMPACT_STORAGE = 'ft-marketplace-retail-admin-compact-rich-text';
const LEXICAL_BOLD_FORMAT = 1;
const LEXICAL_ITALIC_FORMAT = 2;
function isCompactStorageEnabled() {
  try {
    return Boolean(svs.core.detect.feature(FEATURE_TOGGLE_COMPACT_STORAGE));
  } catch (e) {
    return false;
  }
}
function escapeInlineText(text) {
  let escaped = '';
  for (let i = 0; i < text.length; i++) {
    const character = text[i];
    if (character === '\\') {
      escaped += '\\\\';
    } else if (character === '*') {
      escaped += '\\*';
    } else if (character === '_') {
      escaped += '\\_';
    } else if (character === '\n') {
      escaped += '\\n';
    } else {
      escaped += character;
    }
  }
  return escaped;
}
function unescapeInlineText(text) {
  let value = '';
  for (let i = 0; i < text.length; i++) {
    const character = text[i];
    if (character === '\\' && i + 1 < text.length) {
      const nextCharacter = text[i + 1];
      if (nextCharacter === 'n') {
        value += '\n';
        i++;
        continue;
      }
      value += nextCharacter;
      i++;
      continue;
    }
    value += character;
  }
  return value;
}
function appendSegment(segments, text, bold, italic) {
  if (!text) {
    return;
  }
  const lastSegment = segments[segments.length - 1];
  if (lastSegment && lastSegment.bold === bold && lastSegment.italic === italic) {
    lastSegment.text += text;
    return;
  }
  segments.push({
    text,
    bold,
    italic
  });
}
function serializeInlineSegments(segments) {
  return segments.map(segment => {
    const text = escapeInlineText(segment.text || '');
    if (!text) {
      return '';
    }
    if (segment.bold && segment.italic) {
      return "**_".concat(text, "_**");
    }
    if (segment.bold) {
      return "**".concat(text, "**");
    }
    if (segment.italic) {
      return "_".concat(text, "_");
    }
    return text;
  }).join('');
}
function isEscaped(text, index) {
  let slashCount = 0;
  for (let i = index - 1; i >= 0 && text[i] === '\\'; i--) {
    slashCount++;
  }
  return slashCount % 2 === 1;
}
function findClosingToken(text, token, startIndex) {
  for (let i = startIndex; i <= text.length - token.length; i++) {
    if (text.slice(i, i + token.length) === token && !isEscaped(text, i)) {
      return i;
    }
  }
  return -1;
}
function parseInlineSegments(text) {
  const segments = [];
  let buffer = '';
  let index = 0;
  const flushBuffer = () => {
    if (!buffer) {
      return;
    }
    appendSegment(segments, unescapeInlineText(buffer), false, false);
    buffer = '';
  };
  while (index < text.length) {
    if (text.slice(index, index + 3) === '**_') {
      const closingIndex = findClosingToken(text, '_**', index + 3);
      if (closingIndex !== -1) {
        flushBuffer();
        appendSegment(segments, unescapeInlineText(text.slice(index + 3, closingIndex)), true, true);
        index = closingIndex + 3;
        continue;
      }
    }
    if (text.slice(index, index + 2) === '**') {
      const closingIndex = findClosingToken(text, '**', index + 2);
      if (closingIndex !== -1) {
        flushBuffer();
        appendSegment(segments, unescapeInlineText(text.slice(index + 2, closingIndex)), true, false);
        index = closingIndex + 2;
        continue;
      }
    }
    if (text[index] === '_') {
      const closingIndex = findClosingToken(text, '_', index + 1);
      if (closingIndex !== -1) {
        flushBuffer();
        appendSegment(segments, unescapeInlineText(text.slice(index + 1, closingIndex)), false, true);
        index = closingIndex + 1;
        continue;
      }
    }
    buffer += text[index];
    index++;
  }
  flushBuffer();
  return segments;
}
function getTextFormatting(format) {
  const formatValue = typeof format === 'number' ? format : 0;
  return {
    bold: formatValue % (LEXICAL_BOLD_FORMAT * 2) >= LEXICAL_BOLD_FORMAT,
    italic: formatValue % (LEXICAL_ITALIC_FORMAT * 2) >= LEXICAL_ITALIC_FORMAT
  };
}
function collectInlineSegments(node, segments) {
  if (!node) {
    return;
  }
  if (node.type === 'text') {
    const formatting = getTextFormatting(node.format);
    appendSegment(segments, node.text || '', formatting.bold, formatting.italic);
    return;
  }
  if (node.type === 'linebreak') {
    appendSegment(segments, '\n', false, false);
    return;
  }
  if (!Array.isArray(node.children)) {
    return;
  }
  for (let i = 0; i < node.children.length; i++) {
    const child = node.children[i];
    if (child.type === 'list') {
      continue;
    }
    collectInlineSegments(child, segments);
  }
}
function buildParagraphBlock(node) {
  const segments = [];
  collectInlineSegments(node, segments);
  return {
    type: 'paragraph',
    segments
  };
}
function createListBlock(listType) {
  return {
    type: listType === 'number' ? 'ordered-list' : 'unordered-list',
    items: []
  };
}
function listNodeToBlocks(listNode) {
  const blocks = [];
  const listType = listNode && listNode.listType === 'number' ? 'number' : 'bullet';
  let currentListBlock = createListBlock(listType);
  const flushCurrentListBlock = () => {
    if (currentListBlock.items.length > 0) {
      blocks.push(currentListBlock);
      currentListBlock = createListBlock(listType);
    }
  };
  const listItems = Array.isArray(listNode.children) ? listNode.children : [];
  for (let i = 0; i < listItems.length; i++) {
    const listItem = listItems[i];
    const segments = [];
    const nestedLists = [];
    const children = Array.isArray(listItem.children) ? listItem.children : [];
    for (let childIndex = 0; childIndex < children.length; childIndex++) {
      const child = children[childIndex];
      if (child.type === 'list') {
        nestedLists.push(child);
        continue;
      }
      collectInlineSegments(child, segments);
    }
    currentListBlock.items.push(segments);
    if (nestedLists.length > 0) {
      flushCurrentListBlock();
      for (let nestedIndex = 0; nestedIndex < nestedLists.length; nestedIndex++) {
        const nestedBlocks = listNodeToBlocks(nestedLists[nestedIndex]);
        for (let blockIndex = 0; blockIndex < nestedBlocks.length; blockIndex++) {
          blocks.push(nestedBlocks[blockIndex]);
        }
      }
    }
  }
  flushCurrentListBlock();
  return blocks;
}
function lexicalJsonToBlocks(lexicalJsonString) {
  try {
    const parsed = JSON.parse(lexicalJsonString);
    const root = parsed && parsed.root ? parsed.root : {};
    const children = Array.isArray(root.children) ? root.children : [];
    const blocks = [];
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child.type === 'list') {
        const listBlocks = listNodeToBlocks(child);
        for (let blockIndex = 0; blockIndex < listBlocks.length; blockIndex++) {
          blocks.push(listBlocks[blockIndex]);
        }
        continue;
      }
      blocks.push(buildParagraphBlock(child));
    }
    return blocks;
  } catch (e) {
    return [];
  }
}
function serializeBlocks(blocks) {
  return blocks.map(block => {
    if (block.type === 'unordered-list') {
      return block.items.map(item => "- ".concat(serializeInlineSegments(item))).join('\n');
    }
    if (block.type === 'ordered-list') {
      return block.items.map((item, index) => "".concat(index + 1, ". ").concat(serializeInlineSegments(item))).join('\n');
    }
    return serializeInlineSegments(block.segments || '').replace(/\\n(?=- |\d+\. )/g, '\n').replace(/(^|\n)(- |\d+\. )/g, '$1\\$2');
  }).join('\n\n');
}
function textToLexicalNodes(text, format) {
  const nodes = [];
  const lines = text.split('\n');
  for (let i = 0; i < lines.length; i++) {
    if (lines[i]) {
      nodes.push({
        detail: 0,
        format,
        mode: 'normal',
        style: '',
        text: lines[i],
        type: 'text',
        version: 1
      });
    }
    if (i < lines.length - 1) {
      nodes.push({
        type: 'linebreak',
        version: 1
      });
    }
  }
  return nodes;
}
function inlineSegmentsToLexicalNodes(segments) {
  const nodes = [];
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    let format = 0;
    if (segment.bold) {
      format += LEXICAL_BOLD_FORMAT;
    }
    if (segment.italic) {
      format += LEXICAL_ITALIC_FORMAT;
    }
    const textNodes = textToLexicalNodes(segment.text || '', format);
    for (let nodeIndex = 0; nodeIndex < textNodes.length; nodeIndex++) {
      nodes.push(textNodes[nodeIndex]);
    }
  }
  return nodes;
}
function createParagraphNode(segments) {
  const children = inlineSegmentsToLexicalNodes(segments || []);
  return {
    children,
    direction: children.length > 0 ? 'ltr' : null,
    format: '',
    indent: 0,
    type: 'paragraph',
    version: 1
  };
}
function createListNode(block) {
  const children = block.items.map((item, index) => {
    const nodes = inlineSegmentsToLexicalNodes(item || []);
    const paragraphNode = {
      children: nodes,
      direction: nodes.length > 0 ? 'ltr' : null,
      format: '',
      indent: 0,
      type: 'paragraph',
      version: 1
    };
    return {
      children: [paragraphNode],
      direction: nodes.length > 0 ? 'ltr' : null,
      format: '',
      indent: 0,
      type: 'listitem',
      value: index + 1,
      version: 1
    };
  });
  return {
    children,
    direction: children.length > 0 ? 'ltr' : null,
    format: '',
    indent: 0,
    listType: block.type === 'ordered-list' ? 'number' : 'bullet',
    start: 1,
    tag: block.type === 'ordered-list' ? 'ol' : 'ul',
    type: 'list',
    version: 1
  };
}
function blocksToLexicalJson(blocks) {
  const rootChildren = [];
  for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i];
    if (block.type === 'ordered-list' || block.type === 'unordered-list') {
      rootChildren.push(createListNode(block));
      continue;
    }
    rootChildren.push(createParagraphNode(block.segments || []));
  }
  if (rootChildren.length === 0) {
    rootChildren.push(createParagraphNode([]));
  }
  return JSON.stringify({
    root: {
      children: rootChildren,
      direction: rootChildren.length > 0 ? 'ltr' : null,
      format: '',
      indent: 0,
      type: 'root',
      version: 1
    }
  });
}
function parseCompactBody(body) {
  if (!body) {
    return [];
  }
  const rawBlocks = body.split(/\n{2,}/);
  const blocks = [];
  for (let i = 0; i < rawBlocks.length; i++) {
    const rawBlock = rawBlocks[i];
    if (rawBlock === '') {
      continue;
    }
    const lines = rawBlock.split('\n');
    const isBulletList = lines.every(line => /^- /.test(line));
    const isOrderedList = lines.every(line => /^\d+\. /.test(line));
    if (isBulletList) {
      blocks.push({
        type: 'unordered-list',
        items: lines.map(line => parseInlineSegments(line.replace(/^- /, '')))
      });
      continue;
    }
    if (isOrderedList) {
      blocks.push({
        type: 'ordered-list',
        items: lines.map(line => parseInlineSegments(line.replace(/^\d+\. /, '')))
      });
      continue;
    }
    blocks.push({
      type: 'paragraph',
      segments: parseInlineSegments(lines.join('\n'))
    });
  }
  return blocks;
}
function isCompactStorage(value) {
  return typeof value === 'string' && value.indexOf(STORAGE_PREFIX) === 0;
}
function serializeForStorage(richTextState) {
  if (!(richTextState instanceof RichTextState)) {
    return '';
  }
  if (!isCompactStorageEnabled()) {
    return richTextState.getLexicalJson();
  }
  const blocks = lexicalJsonToBlocks(richTextState.getLexicalJson());
  return "".concat(STORAGE_PREFIX).concat(serializeBlocks(blocks));
}
function parseCompactStorage(value) {
  if (!isCompactStorage(value)) {
    return RichTextState.createEmpty();
  }
  const blocks = parseCompactBody(value.slice(STORAGE_PREFIX.length));
  return new RichTextState(blocksToLexicalJson(blocks));
}
function getStorageLength(richTextState) {
  if (!(richTextState instanceof RichTextState)) {
    return 0;
  }
  if (!isCompactStorageEnabled()) {
    return richTextState.getLexicalJson().length;
  }
  return serializeForStorage(richTextState).length;
}
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.STORAGE_PREFIX', STORAGE_PREFIX);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.FEATURE_TOGGLE_COMPACT_STORAGE', FEATURE_TOGGLE_COMPACT_STORAGE);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.isCompactStorageEnabled', isCompactStorageEnabled);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.isCompactStorage', isCompactStorage);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.serializeForStorage', serializeForStorage);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.parseCompactStorage', parseCompactStorage);
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.getStorageLength', getStorageLength);

 })(window);